/* Wonderbewbz homepage sections. Safe to load more than once, re-runs in the theme editor. */
(function () {
  if (window.__wbHome) return;
  window.__wbHome = true;
  document.documentElement.classList.add('wb-js');
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-seen'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;

  /* safety net: anything already scrolled past is shown, even after a fast jump */
  var sweepQ = false;
  function sweep() {
    sweepQ = false;
    document.querySelectorAll('.wb-rv-in:not(.is-seen)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-seen');
    });
  }
  window.addEventListener('scroll', function () { if (!sweepQ) { sweepQ = true; requestAnimationFrame(sweep); } }, { passive: true });
  window.addEventListener('load', sweep);

  function initReveal(root) {
    root.querySelectorAll('.wb-rv-in').forEach(function (el, i) {
      if (!once(el, 'wbRv')) return;
      el.style.transitionDelay = ((i % 4) * 90) + 'ms';
      if (io) io.observe(el); else el.classList.add('is-seen');
    });
    sweep();
  }

  /* stats count-up */
  function initCount(root) {
    root.querySelectorAll('[data-wb-count]').forEach(function (el) {
      if (!once(el, 'wbCt')) return;
      var target = parseFloat(el.dataset.wbCount), suffix = el.dataset.wbSuffix || '';
      if (reduce || !io || isNaN(target)) { return; }
      var ob = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        ob.disconnect();
        var t0 = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min(1, (t - t0) / dur), v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = v + suffix;
          if (p < 1) requestAnimationFrame(tick); else el.textContent = target + suffix;
        })(t0);
      }, { threshold: 0.5 });
      ob.observe(el);
    });
  }

  /* how it works: image swaps as each step scrolls into view */
  function initSteps(root) {
    root.querySelectorAll('[data-wb-steps]').forEach(function (wrap) {
      if (!once(wrap, 'wbSt')) return;
      var steps = wrap.querySelectorAll('.wb-step'), imgs = wrap.querySelectorAll('.wb-steps__media img'),
          badge = wrap.querySelector('.wb-steps__badge');
      function set(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
        imgs.forEach(function (m, j) { m.classList.toggle('is-on', j === i); });
        if (badge) badge.textContent = 'Step ' + (i + 1) + ' of ' + steps.length;
      }
      set(0);
      if (!io) return;
      var ob = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) set([].indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { ob.observe(s); });
    });
  }

  /* stash planner */
  function initCalc(root) {
    root.querySelectorAll('[data-wb-calc]').forEach(function (c) {
      if (!once(c, 'wbCa')) return;
      var tiers;
      try { tiers = JSON.parse(c.querySelector('[data-wb-tiers]').textContent); } catch (e) { return; }
      var bags = c.querySelector('[data-wb-bags]'), ml = c.querySelector('[data-wb-ml]'),
          tot = c.querySelector('[data-wb-total]'), tier = c.querySelector('[data-wb-tier]'),
          price = c.querySelector('[data-wb-price]'), note = c.querySelector('[data-wb-note]'),
          cta = c.querySelector('[data-wb-cta]'), presets = c.querySelectorAll('[data-wb-pick-bags]'),
          book = c.dataset.book, wa = c.dataset.wa, perL = parseFloat(c.dataset.sachets || '10'), perMl = parseFloat(c.dataset.rate || '0.07');

      function flash(el, v) {
        if (el.textContent === v) return;
        el.textContent = v; el.classList.add('is-flash');
        setTimeout(function () { el.classList.remove('is-flash'); }, 300);
      }
      function run() {
        var L = Math.max(0, (+bags.value || 0) * (+ml.value || 0) / 1000);
        var last = tiers[tiers.length - 1];
        flash(tot, parseFloat(L.toFixed(2)) + 'L');
        presets.forEach(function (p) { p.classList.toggle('is-on', +p.dataset.wbPickBags === +bags.value && +p.dataset.wbPickMl === +ml.value); });
        if (L > last.l + 0.05) {
          flash(tier, last.name + '+'); flash(price, 'Custom');
          note.textContent = 'That is a big stash. Message us and we will quote you custom pricing for anything over ' + last.name + '.';
          cta.href = wa; cta.firstChild.nodeValue = 'Get a custom quote ';
          return;
        }
        var feeds = 'Makes roughly ' + Math.round(L * 10) + ' feeds of 100ml.';
        /* Round down to the package below, extra milk is pro-rated at a fixed $ per ml.
           If the next package up costs the same or less, suggest that instead. */
        var t = tiers[0], i;
        for (i = 0; i < tiers.length; i++) { if (tiers[i].l <= L + 0.005) t = tiers[i]; }
        var extraMl = Math.max(0, Math.round((L - t.l) * 1000)), extra = Math.round(extraMl * perMl * 100) / 100;
        var up = null;
        for (i = 0; i < tiers.length; i++) { if (tiers[i].l > t.l) { up = tiers[i]; break; } }
        if (extra > 0 && up && up.p <= t.p + extra) { t = up; extraMl = 0; extra = 0; }
        function money(v) { return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
        flash(tier, t.name);
        flash(price, money(t.p + extra));
        var txt = feeds;
        if (extra > 0) {
          txt += ' Includes ' + money(extra) + ' for the extra ' + extraMl + 'ml.';
        } else if (L < t.l - 0.3) {
          txt += ' You have room to add more bags at the same price.';
        }
        txt += ' Pickup, freeze-drying, quality checks and delivery included.';
        note.textContent = txt;
        var link = book;
        if (/\/products\//.test(book)) {
          var baseUrl = book.split('#')[0].split('?')[0];
          link = baseUrl + '?' + (t.v ? 'variant=' + t.v + '&' : '') + 'size=' + encodeURIComponent(t.name) + '#wb-buy';
        }
        cta.href = link; cta.firstChild.nodeValue = 'Book this size ';
      }
      c.querySelectorAll('[data-wb-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = c.querySelector(b.dataset.wbStep === 'bags' ? '[data-wb-bags]' : '[data-wb-ml]');
          var st = +inp.step || 1;
          inp.value = Math.max(+inp.min || 0, (+inp.value || 0) + (+b.dataset.dir) * st);
          run();
        });
      });
      presets.forEach(function (p) {
        p.addEventListener('click', function () {
          bags.value = p.dataset.wbPickBags; ml.value = p.dataset.wbPickMl;
          run();
        });
      });
      bags.addEventListener('input', run); ml.addEventListener('input', run);
      run();
    });
  }

  /* FAQ accordion */
  function initFaq(root) {
    root.querySelectorAll('.wb-qa__q').forEach(function (q) {
      if (!once(q, 'wbQa')) return;
      q.addEventListener('click', function () {
        var item = q.closest('.wb-qa'), open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open);
      });
    });
  }

  /* mobile sticky booking bar: shows after the hero */
  function initBar() {
    var bar = document.querySelector('.wb-mbar');
    if (!bar || !once(bar, 'wbMb')) return;
    function on() { bar.classList.toggle('is-show', window.scrollY > 700); }
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  function init(root) {
    root = root || document;
    initReveal(root); initCount(root); initSteps(root); initCalc(root); initFaq(root); initBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
